import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useWaiterStore } from '../store/waiterStore';
import { WaiterLoginPage } from '../pages/WaiterLoginPage';

export const WaiterLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { waiter, isAuthenticated, logout } = useWaiterStore();

  if (!isAuthenticated || !waiter) {
    return <WaiterLoginPage />;
  }

  const handleLogout = () => {
    logout();
    navigate('/waiter');
  };

  const navItems = [
    {
      path: '/waiter',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      label: 'Заказы',
      exact: true,
    },
    {
      path: '/waiter/scan',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
        </svg>
      ),
      label: 'Сканер',
    },
  ];

  const isActive = (path: string, exact?: boolean) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Header */}
      <header className="bg-slate-900/80 backdrop-blur-lg border-b border-emerald-500/20 shadow-lg shadow-emerald-500/10 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-14 sm:h-16">
            <div className="flex items-center space-x-3">
              <div className="h-8 sm:h-10 px-3 bg-emerald-600/20 rounded-lg flex items-center justify-center border border-emerald-500/30">
                <span className="text-emerald-400 font-bold text-sm sm:text-base">WAITER</span>
              </div>
            </div>

            <div className="flex items-center space-x-2 sm:space-x-4">
              <span className="text-sm text-slate-300 hidden sm:block">{waiter.name}</span>
              <button
                onClick={handleLogout}
                className="p-2 text-emerald-400/70 hover:text-emerald-400 hover:bg-slate-800/50 rounded-lg transition-all"
                title="Выйти"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 pb-24">
        <Outlet />
      </main>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-slate-900/95 backdrop-blur-lg border-t border-emerald-500/20 z-50">
        <div className="max-w-7xl mx-auto px-2 sm:px-4">
          <div className="flex justify-around items-center h-16">
            {navItems.map((item) => {
              const active = isActive(item.path, item.exact);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex flex-col items-center justify-center flex-1 h-full transition-all duration-200 ${
                    active ? 'text-emerald-400' : 'text-slate-500 hover:text-emerald-400/70'
                  }`}
                >
                  <div className={`${active ? 'scale-110' : ''} transition-transform duration-200`}>
                    {item.icon}
                  </div>
                  <span className="text-[10px] sm:text-xs mt-1 font-medium">{item.label}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </nav>
    </div>
  );
};
